import api from './api';

const unitsApi = api.injectEndpoints({
	endpoints: (build) => ({
		updateUnit: build.mutation({
			query: ({ resourceRateId, slotId, unitId, oldUnitId, oldCaregiverId }) => ({
				url: `/slot/${slotId}/unit-assignment`,
				method: 'PUT',
				body: {
					resourceRateId,
					slotId,
					unitId,
					oldUnitId: oldUnitId?.toString() || null,
					oldCaregiverId: oldCaregiverId?.toString() || null
				}
			})
		}),
		addRecurringShiftUnit: build.mutation({
			query: ({ shiftId, shiftDate, unitId, oldUnitId, oldCaregiverId }) => ({
				url: `/recurring-shifts/${shiftId}/unit-assignment`,
				method: 'PUT',
				body: {
					unitId,
					shiftDate,
					isRecurring: true,
					oldUnitId,
					oldCaregiverId
				}
			})
		}),
		updateFlexUnit: build.mutation({
			query: ({ facilityId, slotId, unitId, oldUnitId, oldCaregiverId }) => ({
				url: `/flex/slot/${slotId}/unit-assignment`,
				method: 'PUT',
				body: {
					facilityId,
					unitId,
					oldUnitId: oldUnitId?.toString() || null,
					oldCaregiverId: oldCaregiverId?.toString() || null
				}
			})
		})
	})
});

export const {
	useUpdateUnitMutation,
	useUpdateFlexUnitMutation,
	unwrapError,
	useAddRecurringShiftUnitMutation
} = unitsApi;

export default unitsApi;
